import { render } from "./ProfileApiTokens.vue?vue&type=template&id=079d5a60"
import script from "./ProfileApiTokens.vue?vue&type=script&lang=js"
export * from "./ProfileApiTokens.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__